import axiosInstance from "./axios-instance";

const ownerBasePath = (ownerType, ownerId) => {
    const paths = {
        person: `/app/documents/people/${ownerId}`,
        engagement: `/app/documents/engagements/${ownerId}`,
    };

    if (!paths[ownerType]) {
        throw new Error(`Unsupported document owner type: ${ownerType}`);
    }

    return paths[ownerType];
};

const listDocuments = (ownerType, ownerId, caseNoteId) =>
    axiosInstance.get(ownerBasePath(ownerType, ownerId), {
        cache: false,
        params: caseNoteId ? { case_note_id: caseNoteId } : undefined,
    }).then(res => res);

const uploadDocument = (ownerType, ownerId, file, description, caseNoteId) => {
    const formData = new FormData();
    formData.append("file", file);
    if (description) {
        formData.append("description", description);
    }
    if (caseNoteId) {
        formData.append("case_note_id", caseNoteId);
    }

    return axiosInstance.post(ownerBasePath(ownerType, ownerId), formData, {
        headers: { "Content-Type": "multipart/form-data" },
    }).then(res => res);
};

const downloadDocument = (ownerType, ownerId, documentId) =>
    axiosInstance.get(`${ownerBasePath(ownerType, ownerId)}/${documentId}`, {
        cache: false,
        responseType: "blob",
    }).then(res => res);

const deleteDocument = (ownerType, ownerId, documentId) =>
    axiosInstance.delete(`${ownerBasePath(ownerType, ownerId)}/${documentId}`).then(res => res);

export default {
    listDocuments,
    uploadDocument,
    downloadDocument,
    deleteDocument,
};
